export const formTranslations = {
  // Search and input placeholders
  AskAQuestion: '질문을 물어보세요',
  TypeSearchWord: '검색어를 입력하세요',
  SearchWithinMySpace: '찾고 싶은 자료를 검색하세요',
  EnterSearchQuery: '추가할 검색어를 입력하세요',
  EnterSearchQueryPlaceholder: '쿼리를 입력하거나 수정하세요',
  SearchQueryInput: '검색어 쿼리 입력',
  PleaseEnterTheWebsiteURL: '웹사이트 URL을 입력해 주세요',

  // Email form fields
  DraftEmail:
    '보내려는 메일을 간략하게 설명해 주세요. 이를 바탕으로 메일 초안을 만들어 드립니다.',
  EmailPlaceholder: '이전 대화 내역을 기입해주세요',
  TemplateText: '템플릿',
  EmailTone: '어투',
  EmailLanguage: '언어',
  EmailThread: '대화 내역',
  EmailAutomatic: '자동',
  EmailPoliteness: '정중',
  EmailFriendly: '친근',
  EmailConcise: '간결',

  // Draft and writing forms
  DraftTextFieldPlaceholder: '다듬고 싶은 글이나 초안을 입력해주세요',
  DraftTonePlaceHolder: '대상 또는 원하는 톤을 설명해 주세요',
  DraftDetailsTextFieldPlaceholder:
    '추가 세부 정보를 입력해 주세요. 더 정확하게 내용을 생성할 수 있어요!',
  RefineCommandPlacerHolder: '명령 입력',

  // Style and formatting options
  SentenceLength: '문장 길이',
  DocumentLength: '문서 길이',
  ToneNManner: '톤앤 매너',
  Auto: '자동',
  Politeness: '공손',
  Friendly: '친근',
  Simple: '간단명료',
  Target: '대상',
  Business: '비즈니스',
  Casual: '캐주얼',
  Custom: '사용자 지정',

  // Length options
  VeryBriefly: '매우 짧게',
  Short: '짧게',
  MaintainCurrentLength: '현재 길이 유지',
  Long: '길게',
  VeryLong: '매우 길게',
  Commonly: '보통',

  // Summary options
  Style: '형식',
  Length: '길이',
  SummaryBasic: '줄글',
  ThesisAbstract: '초록',
  Grid: '개조식',
  Graph: '표',

  // Grammar and editing options
  Grammarcorrections: '문법/오타 수정',
  SimpleFix: '간단한 수정',
  FullEdit: '전체 수정',
  AdditionalModifications: '추가 수정',

  // Workspace and project forms
  AddTitle: '제목을 입력하세요',
  AddEmailandPressEnter: '이메일을 입력하고 엔터를 누르세요',
  ChangeWorkspaceName: '이름 바꾸기',
  WorkSpaceSearch: '검색하기',
  SearchProject: '프로젝트 검색',

  // Description fields
  DetailsTitle: '세부 정보',
  EnterDescriptionForTheKeyword:
    '생성할 키워드에 대한 설명 문장을 입력하여 주세요',

  // Language selection
  ChooseLanguage: '한국어',
  LanguageSearch: '언어 검색',

  // Invitation Toast
  InvitationSent: '초대 메일을 전송했습니다!',
  InvitationReSent: '초대 메일을 재전송했습니다!',
}
